import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import { urlify } from '../../../utils/string';
import s from './Heading.scss';

const Heading = ({ content, attrs = {}, isPuffContent = false, inlineCategoryContent = false }) => {
	const style = {};
	const HeadingTag = `h${content?.level || '2'}`;
	if (attrs.textColor) style.color = attrs.textColor;
	if (attrs.textAlign) style.textAlign = attrs.textAlign;

	content.rawText = content.rawText.replace(/<em>\s*<\/em>/, '');

	let headingClasses = [s.heading, `u_header__${content?.level || '2'}`];
	if (attrs.className) headingClasses = [...headingClasses, ...attrs.className.map((cN) => s[`heading${cN}`])];
	if (content.rawText.trim().indexOf('<em') !== -1) {
		headingClasses.push('u_header__hasEm');
	} else {
		headingClasses.push('u_header__noEm');
	}
	if (inlineCategoryContent) headingClasses.push(s.heading__inlineCategoryContent);

	const headingInnerClasses = [s.heading_inner];
	if (attrs.fontSize) headingInnerClasses.push(`u_fontSize__${parseInt(attrs.fontSize, 10)}`);
	if (content.rawText.trim().lastIndexOf('>') === content.rawText.trim().length - 1) headingInnerClasses.push(s.heading_inner__emOnly);

	return (
		<div id={urlify(purifier(content.rawText, { ALLOWED_TAGS: ['#text'], KEEP_CONTENT: true }).slice(0, 50))} className={headingClasses.join(' ')} style={style}>
			<HeadingTag className={headingInnerClasses.join(' ')} dangerouslySetInnerHTML={{ __html: purifier(content.rawText) }} />
		</div>
	);
};

export default hot(module)(Heading);
